import React, { Component } from 'react';
import Bars from './Bars.jsx';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class StackBars extends Component {
  constructor(props) {
    super(props)
  }
  componentWillUnmount(){
    hideDetail();    
  }
  onStackBarClick=(xAxisLabels,yAxisValue,name,oriDatum,xAxisPosition,xAxisScale,yAxisScale,tooltipStyle,height,margins,id,showStackBarTooltip,datum,onStackBarClick,hideStackBarTooltip,closeIconStyle,tooltipConfig)=>{
    oriDatum.tooltipConfig=tooltipConfig || {};
    var data={
      xAxisLabels:xAxisLabels,
      yAxisValue:yAxisValue,
      name:name,
      data: oriDatum,
      positionInfo:{x:xAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum[1])),tooltipStyle:tooltipStyle,barHeight:(yAxisScale.scale(datum[0]) - yAxisScale.scale(datum[1])),id:id,isDataTip:true,closeIconStyle:closeIconStyle}
    };
    if(onStackBarClick!=undefined && (oriDatum.enableClick==undefined || oriDatum.enableClick==true) ){
      hideDetail();
      onStackBarClick(data);
      // hideStackBarTooltip();
      // onStackBarClick(data,function(result){
      //   if(result.component && typeof(result.component)=='object'){
      //     showStackBarTooltip(result.component,{x:xAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum[1])),tooltipStyle:tooltipStyle,barHeight:(yAxisScale.scale(datum[0]) - yAxisScale.scale(datum[1])),id:id,isDataTip:true});
      //   }
      // });
    }
  }

  render() {
    const { primaryXAxis,secondoryYAxis, primaryYAxis, secondorXAxis, svgDimensions,margins,chartConfigWithBar,isStackBarChart,
        stackBarKeys,stackLayers,stackBarData,isStackLabelsRequired,stackLabels,id,showStackBarTooltip,hideStackBarTooltip } = this.props
    const { height } = svgDimensions;
    const totalLayers=stackLayers.length;
    var format=function(d){
      return d;
    };//"0,0.[00]"
    var formatLabel=function(d){
      return d;
    };//"0,0.[00]"
    var that=this;
    return (
      <g>
          {
            stackLayers.length && stackLayers.map(function(d,index){
                var key=d.key;
                return <g key={index} transform={"translate(0,0)"}>
                   {d.length && d.map(function(d1,indexBar){
                    format=d1["data"]["dataLabels_"+index]["format"] || format; 
                     var prefix=d1["data"]["dataLabels_"+index]["prefix"] || "";
                     var postfix=d1["data"]["dataLabels_"+index]["postfix"] || "";
                     var oriDatum=d1["data"]['oriData_'+index];
                     return (<g key={index+"_StackBarG_"+indexBar}>
                            <rect key={index+"_StackBarRect_"+indexBar}
                              x={primaryXAxis.scale(d1[0])}
                              y={primaryYAxis.scale(d1.data.yCategory)}
                              height={primaryYAxis.scale.bandwidth()}
                              width={primaryXAxis.scale(d1[1]) - primaryXAxis.scale(d1[0])}
                              fill={(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.fillColor != null) ? (oriDatum.fillColor) :d1["data"]["fillColor_"+index]}
                              fillOpacity={d1["data"]["fillOpacity_"+index] || 1}
                              style={{cursor:d1["data"]["onStackBarClick_"+index] ?
                                ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
                              : "default",stroke:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.stroke != null) ? (oriDatum.stroke) :'none',
                              strokeWidth:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.strokeWidth != null) ? (oriDatum.strokeWidth) :'0px',
                              outlineColor:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineColor != null) ? (oriDatum.outlineColor) :'transparent',
                              outlineStyle:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineStyle != null) ? (oriDatum.outlineStyle) :'hidden',
                              outlineWidth:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineWidth != null) ? (oriDatum.outlineWidth) :'0px',
                              outlineOffset:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineOffset != null) ? (oriDatum.outlineOffset) :'0px'
                              }}
                              onMouseEnter={(mouseEvent)=>{d1["data"]["tooltip_"+index] ? d1["data"]["tooltip_"+index]===true ? 
                              showDetail({id:id,margins:margins,tooltip:d1["data"]["tooltip_"+index] || {}},[{x:d1["data"]["yCategory"],[d1["data"]["name_"+index]]:d1["data"]["stackKey_"+index],Total:d1["data"]["stackTotal"]}],mouseEvent,d1["data"]["tooltipStyle_"+index],d1["data"]["tooltipPosition_"+index]):
                              showStackBarTooltip(d1["data"]["tooltip_"+index]["component"]||'<g class="tooltipg"></g>',{x:(primaryYAxis.scale(d1.data.yCategory)),bandwidth:primaryYAxis.scale.bandwidth(),y:(primaryXAxis.scale(d1[1])),tooltipStyle:d1["data"]["tooltipStyle_"+index],barHeight:(primaryXAxis.scale(d1[0]) - primaryXAxis.scale(d1[1]))}): ''}}
                              onMouseOut={(mouseEvent)=>{d1["data"]["tooltip_"+index] ? d1["data"]["tooltip_"+index]===true ? hideDetail() : hideStackBarTooltip(): ''}}
                              onMouseMove={(mouseEvent)=>{d1["data"]["tooltip_"+index] ? (d1["data"]["tooltip_"+index]===true && d1["data"]["tooltipPosition_"+index].toLowerCase()=="cursor" ) ? 
                              showDetail({id:id,margins:margins,tooltip:d1["data"]["tooltip_"+index] || {}},[{x:d1["data"]["yCategory"],[d1["data"]["name_"+index]]:d1["data"]["stackKey_"+index],Total:d1["data"]["stackTotal"]}],mouseEvent,d1["data"]["tooltipStyle_"+index],d1["data"]["tooltipPosition_"+index]):'': ''}}
                              onClick={()=>{that.onStackBarClick(d1["data"]["yCategory"],d1[1],d1["data"]["name_"+index],((oriDatum!=null && typeof(oriDatum)=='object') ? oriDatum : {}),primaryYAxis.scale(d1.data.yCategory),primaryYAxis,primaryXAxis,d1["data"]["tooltipStyle_"+index],height,margins,id,showStackBarTooltip,d1,d1["data"]["onStackBarClick_"+index],hideStackBarTooltip,d1["data"]["closeIconStyle_"+index],d1["data"]["tooltipConfig_"+index])}}
                            >
                            </rect>
                            {d1["data"]["dataLabels_"+index] && d1["data"]["dataLabels_"+index]["enabled"]==true && <text
                            key={index+"_StackBarRectText_"+indexBar}
                            x={primaryXAxis.scale((d1[1]+d1[0])/2)}
                            y={primaryYAxis.scale(d1.data.yCategory)+(primaryYAxis.scale.bandwidth()/2)}
                            fill='#000'
                            style={$.extend({'textAnchor':'middle','pointerEvents':'none'},false,d1["data"]["dataLabels_"+index]["style"] && d1["data"]["dataLabels_"+index]["style"] ? d1["data"]["dataLabels_"+index]["style"] :{})}
                       >{prefix + "" + customFormat(d1["data"]["stackInnerText_"+index],format)+""+postfix} </text>}
                            </g>)
                   })}
                  {index==(totalLayers-1) && isStackLabelsRequired==true &&
                    d.length && d.map(function(d1,index){
                    formatLabel=stackLabels["format"] || (d1["data"]["tooltipStyle_"+index] && d1["data"]["tooltipStyle_"+index]["format"]) ||  formatLabel; 
                    var prefix=stackLabels["prefix"] || (d1["data"]["tooltipStyle_"+index] && d1["data"]["tooltipStyle_"+index]["prefix"]) ||"";
                    var postfix=stackLabels["postfix"] || (d1["data"]["tooltipStyle_"+index] && d1["data"]["tooltipStyle_"+index]["postfix"]) || "";
                     return  <text
                            key={index}
                            x={primaryXAxis.scale(d1[1])+5}
                            y={primaryYAxis.scale(d1.data.yCategory)+(primaryYAxis.scale.bandwidth()/2)}
                            fill='#000'
                            style={$.extend({'textAnchor':'start'},false,(stackLabels && stackLabels.style ? stackLabels.style :{}))}
                            >{prefix +""+customFormat(d1[1],formatLabel) +""+postfix}</text>
                   })
                  }
                </g>
              })
          }
          { React.Children.count(this.props.children) ? 
          <g className="stackBarChildComponent">
            { React.Children.map(this.props.children,function(child,index){
                return (<g key={index}  className="stackBarChildComponent">{child}</g>);
              })
            }
          </g> 
          : null
          }  
      </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,tooltipStyle,tooltipPosition) {
  if(props.tooltip===true){
    var x=parseFloat(d3.select(mouseEvent.target).attr("x"))+(parseFloat(d3.select(mouseEvent.target).attr("width"))/2);
    var y=parseFloat(d3.select(mouseEvent.target).attr("y"));
    data.map(function(d) {
      var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
      var labelFontColor =tooltipStyle.labelFontColor ||  "black";
      var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
      var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
      var valueFontColor =tooltipStyle.valueFontColor ||  "black";
      var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
      var defaultDataLabelFormat=function(d){
        return d;
      };//"0,0.[00]"
      var format=tooltipStyle.format || defaultDataLabelFormat;
      var prefix=tooltipStyle.prefix || '';
      var postfix=tooltipStyle.postfix || '';
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["x"]
      }</td></tr>`;
      delete d.x;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
            prefix +customFormat(d[data],format)+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor") ? mouseEvent.clientX : x+ $("#" + props.id).offset().left;//d3.event.x;
      d["y"] = (tooltipPosition=="cursor") ? mouseEvent.clientY : y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,false);//isMouseMove isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
